import React from 'react';
import { FaTimes } from 'react-icons/fa';
import './ImageModal.css';

function ImageModal({ image, name, onClose }) {
  return (
    <div className="image-modal-overlay" onClick={onClose}>
      <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="image-modal-close" onClick={onClose} aria-label="Close">
          <FaTimes />
        </button>
        <img 
          src={image} 
          alt={name}
          className="image-modal-image"
          onError={(e) => {
            e.target.src = 'https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400';
          }}
        />
        <h3 className="image-modal-title">{name}</h3>
      </div>
    </div>
  );
}

export default ImageModal;

